<div class="modal">
  <div id="header">
    <div class="header-row">
      <div class="title">
        <mat-icon fontSet="material-icons-round" class="close">post_add</mat-icon>
        <span class="kbody-huge">Catalog Suggestion Details</span>
      </div>
      <mat-icon fontSet="material-icons-round" class="close" (click)="closeModal()">close</mat-icon>
    </div>
    <div class="admin-button-row" *ngIf="!isLoading && getCourseItemId()">
      <div class="btn" (click)="openUploadDocumentsModal()">
        <mat-icon fontSet="material-icons-round" class="icon">upload</mat-icon>
        <span class="kbody-medium">Upload Docs</span>
      </div>
    </div>
  </div>
  <div class="modal-content">
    <app-loading-spinner class="spinner" *ngIf="isLoading"></app-loading-spinner>
    <app-catalog-suggestion-review 
      [showStatusRow]="true" 
      [enableDocumentUpload]="false"
      *ngIf="!isLoading" 
      [course]="course"
      (documentsUploaded)="onDocumentsUploaded()">
    </app-catalog-suggestion-review>
  </div>
  <div *ngIf="!isLoading" class="buttons">
    <app-button (click)="cancelSuggestion()" [class]="'red'" [text]="'Cancel Suggestion'"></app-button>
    <app-button (click)="closeModal()" [class]="'grey'" [text]="'Close this Window'"></app-button>
  </div>
  <ng-container *ngIf="!isLoading && showUploadDocumentsModal && getCourseItemId()">
    <app-upload-course-documents 
      [courseItemId]="getCourseItemId()"
      (closeModal)="closeUploadDocumentsModal()"
      (documentsUploaded)="onDocumentsUploaded()">
    </app-upload-course-documents>
  </ng-container>
</div>
